{
	"areYouSureYouWant": "Are you sure you want to delete {{var0}}? Your local photos files will not be affected.",
	"deleteProject": "Delete Project",
	"deleteWarning": "Cleanup .catalog file. This action cannot be undone.",
	"deletingProject": "Deleting project..."
}
